import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/permission' // permission control

import VueClipboard from 'vue-clipboard2'//复制到剪切板

import PrimaryButton from '@/views/newui/component/primaryButton/index.vue'

Vue.component('PrimaryButton', PrimaryButton)


Vue.use(ElementUI, {locale, size: 'small'})

Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})
